import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { UserInfo } from '../models/user-info.model';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { User } from './models/user-info.model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MyService {

private baseUrl = environment.apiBaseUrl;  // استفاده از baseUrl

  constructor(private http: HttpClient) {}

  // getAll(): Observable<User[]> {
  //   return this.http.get<User[]>(this.baseUrl);
  // }

  add(user: User): Observable<User> {
    return this.http.post<User>(this.baseUrl, user);
  }

  update(user: User): Observable<any> {
    return this.http.put(`${this.baseUrl}/${user.id}`, user);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}